import React, { useEffect } from 'react'
import "./terms.scss"
import Footer from '../landing/footer/Footer'
import { useTheme } from '../../contexts/ThemeProvider'
import { LIGHT_THEME } from '../../utils/constants'
import SEO from '../SEO'

const Privacy = () => {
    const { theme } = useTheme();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <SEO
                url='https://www.rain.one/privacy-policy'
            />
            <section className="terms-section">
                {
                    theme != LIGHT_THEME ? <img src="\assets\terms-bgdark.png" alt="img" className='img-fluid terms-bg' /> :
                        <img src="\assets\terms-bg.png" alt="img" className='img-fluid terms-bg' />
                }
                <div className="custom-container">
                    <div className="main-text">
                        <h2>Privacy Policy</h2>
                    </div>
                    <div className="bottom-content">
                        <p className="date-text">Last Modified: 27.10.2025</p>
                        <p className="version-text">Effective Date: 27.10.2025</p>

                        <h5>1. INTRODUCTION</h5>
                        <p>This Privacy Policy ("Policy") explains how Token Factory ("Company", "we", "us", or "our"), a company incorporated under the laws of Panama, collects, uses, and protects information in connection with the Rain prediction markets platform accessible at rain.one and through our decentralized protocol interface (collectively, the "Platform" or "Services").</p>
                        <p>By accessing or using the Platform, you acknowledge that you have read and understood this Privacy Policy and agree to its terms. If you do not agree, please discontinue use of the Platform immediately.</p>

                        <h5>2. INFORMATION WE COLLECT</h5>

                        <h6>2.1 Public Blockchain Data</h6>
                        <p>When you connect your wallet to Rain, we collect and log your publicly-available blockchain address to: Enable platform functionality and display your positions, Screen wallets for compliance with anti-money laundering regulations, Prevent fraudulent or illicit activities.</p>
                        <p><strong>Important:</strong> Blockchain addresses and all associated transactions are publicly-available data on Arbitrum, Ethereum, BNB Chain and others. This data is permanent and cannot be deleted.</p>

                        <h6>2.2 Limited Off-Chain Data</h6>
                        <p>We automatically collect non-identifiable technical information including: device type and operating system, browser type and version, general geographic location (country/region level), platform features used, session duration and frequency and wallet connection method.</p>

                        <h6>2.3 Information You Provide</h6>
                        <p>We only collect personal information that you specifically provide to us such as support communications (If you contact us for support) and email Address (only if you opt-in for notifications or announcements from us (you can unsubscribe anytime).</p>

                        <h6>2.4 What We DON'T Collect</h6>
                        <p>We do NOT collect or store your name, physical address, or date of birth, IP addresses. We do NOT have access to your private keys or seed phrases.</p>

                        <h5>3. HOW WE USE INFORMATION</h5>

                        <h6>3.1 Platform Operations</h6>
                        <p>We use the data we collect to process market transactions and display your positions, enable oracle resolutions through Delphi AI, handle dispute resolution processes, calculate and distribute market payouts, enable user-to-user communications on the Platform.</p>

                        <h6>3.2 Security</h6>
                        <p>We use the data we collect to detect and prevent fraud, market manipulation, and illicit activities through automated risk and fraud detection tools, and maintain platform security and integrity.</p>

                        <h6>3.3 Platform Improvement</h6>
                        <p>We use the data we collect to analyze aggregated usage patterns to improve user experience, develop new features and optimize existing ones, fix bugs and technical issues, conduct research on prediction market mechanics.</p>

                        <h5>4. INFORMATION SHARING</h5>

                        <h6>4.1 We Never Sell Your Data</h6>
                        <p>We do not and will never sell, rent, or trade your personal information to third parties.</p>

                        <h6>4.2 Service Providers</h6>
                        <p>We may share limited information with oracle services, infrastructure providers and security partners.</p>

                        <h6>4.3 Legal Obligations</h6>
                        <p>We may disclose information when required by court orders or subpoenas, government or regulatory requests with proper legal authority.</p>

                        <h6>4.4 Public Blockchain Disclosure</h6>
                        <p>All transactions on Rain are recorded on public blockchains. This means your wallet address is publicly visible, all public market positions and trades are permanent public records, and transaction amounts and timestamps are visible to anyone. This data cannot be modified or deleted by us or anyone else.</p>

                        <h5>5. CROSS-CHAIN DATA</h5>
                        <p>Rain operates across multiple blockchains. When you use cross-chain features transactions on each chain are independently public and bridge operations may be correlated across chains. We process deposits across supported networks automatically.</p>

                        <h5>6. DATA RETENTION</h5>

                        <h6>6.1 Blockchain Data</h6>
                        <p>Permanent and immutable on public blockchains.</p>

                        <h6>6.2 Technical Logs</h6>
                        <p>Retained for 12 months for security purposes.</p>

                        <h6>6.3 Support Communications</h6>
                        <p>3 years or until resolution.</p>

                        <h6>6.4 Email Lists</h6>
                        <p>Until you unsubscribe.</p>

                        <h6>6.5 Other Data</h6>
                        <p>Only as long as necessary for legal or operational requirements. We will retain all records for such time period as may be required by applicable law.</p>

                        <h5>7. THIRD-PARTY PAYMENT PROCESSORS AND WALLET PROVIDERS</h5>
                        <p>When you interact with Rain through wallet providers (such as MetaMask, WalletConnect, or similar services):</p>


                        <p>7.1 You authorize these third-party providers to collect, process, and store your transaction information in accordance with their respective privacy policies.</p>


                        <p>7.2 We do not have access to or control over the private keys managed by your wallet provider.</p>


                        <p>7.3 Financial information processed through these providers is subject to their terms and privacy policies.</p>


                        <p>7.4 We recommend reviewing the privacy policies of any wallet provider you use.</p>

                        <h5>8. INTERNATIONAL DATA TRANSFERS</h5>
                        <p>As a Panama-based company serving global users your information may be processed outside your country of residence. We implement appropriate safeguards for international data transfers. By using the Platform, you consent to such transfers.</p>

                        <h5>9. YOUR RIGHTS AND CHOICES</h5>

                        <h6>9.1 You Can Always:</h6>
                        <p>View your on-chain data through any blockchain explorer, disconnect your wallet from the Platform, opt-out of any email communications, and request deletion of off-chain data we hold about you.</p>

                        <h6>9.2 Limitations Due to Blockchain Technology:</h6>
                        <p>On-chain data cannot be modified or deleted. Transaction history is permanently public. We cannot prevent others from viewing public blockchain data. Wallet addresses and associated transactions remain visible on all supported blockchains.</p>

                        <h5>10. SECURITY</h5>
                        <p>We implement industry-standard security measures including smart contract audits by reputable firms, encryption of data in transit, and regular security assessments. However, no system is fully secure at all times. You are responsible for keeping your private keys and seed phrases secure, using secure internet connections and maintaining good wallet security practices.</p>

                        <h5>11. ORACLE AND AI SYSTEMS</h5>
                        <p>Rain uses Delphi AI oracle for market resolutions. Oracle decisions are recorded on-chain. Dispute data is processed when challenges are filed. Human oracle escalation data is retained for audit purposes. All resolution data becomes part of the permanent blockchain record.</p>

                        <h5>12. GOVERNANCE PARTICIPATION</h5>
                        <p>If you participate in $RAIN token governance know that voting records are public on-chain, proposals and comments are permanently visible and delegation information is publicly recorded.</p>

                        <h5>13. COOKIES AND TRACKING</h5>
                        <p>We use essential cookies for maintaining your session, remembering your preferences (like selected markets) and security functions.</p>

                        <h5>14. MINORS</h5>
                        <p>Rain is not intended for children under 18 years of age. No one under age 18 may provide any personal information to or use the Platform. We do not knowingly collect information from persons under 18. If we obtain actual knowledge that we have collected personal information from a person under the age of 18, we will promptly delete it, unless we are legally obligated to retain such data.</p>

                        <h5>15. THIRD-PARTY SERVICES</h5>
                        <p>When you use Rain, you may interact with wallet providers (MetaMask, WalletConnect, etc.), block explorers, price feed oracles and cross-chain bridges. These services have their own privacy policies and practices.</p>

                        <h5>16. NO REFUND POLICY ACKNOWLEDGMENT</h5>
                        <p>You acknowledge that all prediction market positions are final. Transaction data is permanently recorded and market outcomes cannot be reversed after resolution.</p>

                        <h5>17. CHANGES TO THIS POLICY</h5>
                        <p>We may update this Privacy Policy from time to time. When we make material changes, we will update the "Last Modified" date. We will provide notice through the Platform interface. Your continued use after changes indicates acceptance of the updated Policy.</p>

                        <h5>18. DATA PROTECTION CONTACT</h5>
                        <p>For privacy-related inquiries please contact us at ******* (add email).</p>

                        <h5>20. JURISDICTION</h5>
                        <p>The Rain Platform is made available by Token Factory incorporated in Panama and is not intended to subject us to the laws or jurisdiction of any state, country or territory other than that of Panama. By using the Platform, you agree that any disputes arising from or relating to this Privacy Policy shall be governed by the laws of Panama, without regard to conflict of law principles.</p>


                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Privacy
